export const VRI_TYPES = ['VRI Pre Scheduled', 'VRI On Demand'];

export const isVriType = (type) => VRI_TYPES.includes(type);
